import { For, Show } from 'solid-js';
import { toastHistory, clearToastHistory, notifCenterOpen, toggleNotifCenter } from '../state';

const ICONS = { info: 'i', success: '✓', warn: '!', danger: '×' } as const;

function fmt(ts: number): string {
  const d = Date.now() - ts;
  if (d < 60_000) return 'just now';
  if (d < 3_600_000) return `${Math.floor(d / 60_000)}m ago`;
  if (d < 86_400_000) return `${Math.floor(d / 3_600_000)}h ago`;
  return `${Math.floor(d / 86_400_000)}d ago`;
}

export function NotificationCenter() {
  return (
    <Show when={notifCenterOpen()}>
      <div class="notif-backdrop" onClick={() => toggleNotifCenter(false)}>
        <div class="notif-panel" onClick={(e) => e.stopPropagation()}>
          <div class="notif-head">
            <h3>Notifications</h3>
            <div class="notif-actions">
              <Show when={toastHistory().length > 0}>
                <button class="btn ghost" onClick={clearToastHistory}>Clear</button>
              </Show>
              <button class="btn ghost" onClick={() => toggleNotifCenter(false)}>×</button>
            </div>
          </div>
          <div class="notif-list">
            <Show when={toastHistory().length === 0}>
              <div class="notif-empty">No notifications yet.</div>
            </Show>
            <For each={toastHistory()}>
              {(t) => (
                <div class={`notif-item ${t.severity}`}>
                  <span class="notif-icon">{ICONS[t.severity]}</span>
                  <div class="notif-body">
                    <div class="notif-title">{t.title}</div>
                    <Show when={t.body}><div class="notif-sub">{t.body}</div></Show>
                  </div>
                  <span class="notif-time">{fmt(t.timestamp)}</span>
                </div>
              )}
            </For>
          </div>
        </div>
      </div>
    </Show>
  );
}
